// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + "svber" + "." + "5f366012" + ".chunk.js");